<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #f3f4f4">
			<el-col :xs="24" :md="3" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px; height: 16px; margin-right: 12px" src="../../../assets/img/user-list.png" />用户列表
			</el-col>

			<el-col :xs="24" :md="3" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<el-select style="width: 95%" v-model="dataForm.userType" placeholder="用户类型" @change="getvalue" filterable :disabled="isSourceOfTax == 1 ? true : false">
				<el-option v-for="item in jiesuan" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right">
				<el-form-item>
					<el-button v-if="$hasPermission('user:userList:save') && dataForm.userType != 'gryh'" class="addBtn" type="primary" @click="addOrUpdateHandle()">
						{{ $t("add") }}(企业用户)
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click="hanleExportPhone()" class="exportBtn" v-if="dataForm.userType == 'gryh'" type="default">
					导出电话核查表</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click="bathImportUser('批量导入个人用户', 1)" class="exportBtn" v-if="dataForm.userType == 'gryh'"
					type="default">批量导入个人用户</el-button>
				</el-form-item>
				<!-- <el-form-item>
								<el-button @click="downloadTem()"
									class="exportBtn" v-if="dataForm.userType == 'gryh'" type="default">下载模版</el-button>
							</el-form-item> -->

				<!-- <el-form-item>
								<el-button @click="bathImportUserDown"
									class="exportBtn" v-if="dataForm.userType == 'gryh'" type="default">下载用户检测模板</el-button>
							</el-form-item>
							-->
				<el-form-item>
					<el-button v-if="$hasPermission('user:userList:export')" @click="exportHandle()" class="exportBtn"
					type="default">{{ $t("export") }}</el-button>
				</el-form-item>
				<el-form-item>
					<el-button class="refreshBtn" type="default" @click="getDataList()">刷新</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button
					v-if="$hasPermission('user:userList:delete')"
					class="delBtn"
					type="danger"
					@click="deleteHandle()"
					>{{ $t("deleteBatch") }}</el-button
					>
				</el-form-item> -->
				</el-form>
			</el-col>
		</el-row>

		<div class="mod-sys__user">
			<el-row style="border-bottom: 3px solid #f3f4f4; padding-bottom: 10px">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-form-item style="margin-top: 20px; margin-left: 20px" v-if="dataForm.userType == 'qyyh'" label="企业名称:">
					<el-input v-model="dataForm.caName" placeholder="企业名称" clearable></el-input>
				</el-form-item>
				<el-form-item style="margin-top: 20px; margin-left: 20px" label="用户名称:">
					<el-input v-model="dataForm.username" placeholder="用户名称" clearable></el-input>
				</el-form-item>
				<el-form-item style="margin-top: 20px; margin-left: 20px" v-if="dataForm.userType == 'gryh'" label="姓名:">
					<el-input v-model="dataForm.realName" placeholder="姓名" clearable></el-input>
				</el-form-item>
				<el-form-item style="margin-top: 20px; margin-left: 20px" v-if="dataForm.userType == 'gryh'" label="身份证:">
					<el-input v-model="dataForm.idCard" placeholder="身份证" clearable></el-input>
				</el-form-item>
				<el-form-item style="margin-top: 20px; margin-left: 20px" label="审核状态:" v-if="isSourceOfTax != 1">
					<el-select style="width: 100%" v-model="dataForm.userStatus" placeholder="请选择" clearable>
					<!-- <el-select style="width: 100%" v-model="dataForm.userStatus" placeholder="请选择" clearable v-if="dataForm.bodyId == '1453241566079012865'"> -->
						<el-option :key="0" label="待提交" :value="0"></el-option>
						<el-option :key="1" label="待审核" :value="1"></el-option>
						<el-option :key="2" label="已审核" :value="2"></el-option>
					</el-select>
					<!-- <el-select style="width: 100%" v-model="dataForm.caStatus" placeholder="请选择" clearable v-else>
						<el-option v-for="(item,index) in caStatus" :key="item.value" :value="item.value" :label="item.label"></el-option>
					</el-select> -->
				</el-form-item>
				<el-form-item style="margin-top: 20px; margin-left: 20px" label="税源地:" v-if="dataForm.userType == 'qyyh'">
					<el-select class="select-body" v-model="dataForm.bodyId" filterable placeholder="请选择" @change="handleChangeBodyId" style="width:80%" :disabled="isSourceOfTax == 1">
						<el-option
							v-for="item in bodyInfo"
							:key="item.id"
							:label="item.abbreviation"
							:value="item.id"
							class="option-body">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="dataForm.userType == 'gryh'" style="margin-top: 20px; margin-left: 20px" label="注册时间:">
					<el-date-picker v-model="dataForm.month" type="month" value-format="yyyy-MM" style="width: 202px"
					placeholder="选择月">
					</el-date-picker>
				</el-form-item>
				<el-form-item style="margin-top: 20px; margin-left: 20px">
					<el-button type="primary" @click="getDataList()">执行{{ $t("query") }}</el-button>
				</el-form-item>
				</el-form>
			</el-row>
			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle" style="width: 100%" height="100%">
				<el-table-column type="selection" key="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
					</el-table-column>
				<el-table-column prop="userCode" key="userCode" label="编码" header-align="center" align="center"></el-table-column>
				<el-table-column prop="userType" key="userType" label="用户类型" header-align="center" align="center">
					<template slot-scope="scope">
						{{ $getDictLabel("userType", scope.row.userType) }}
					</template>
				</el-table-column>
				<el-table-column v-if="dataForm.userType == 'gryh'" prop="username" key="username" label="用户名" header-align="center" align="center"></el-table-column>
				<el-table-column v-if="dataForm.userType == 'qyyh'" prop="caName" key="caName" label="企业名称" header-align="center" align="center"></el-table-column>
				<el-table-column v-if="dataForm.userType == 'qyyh'" prop="username" key="username" label="用户名称" header-align="center" align="center">
					<template slot-scope="scope">
						{{scope.row.username == null ? scope.row.username : scope.row.username }}
					</template>
				</el-table-column>
				<el-table-column v-if="dataForm.userType == 'gryh'" prop="realName" key="realName" label="真实姓名" header-align="center" align="center"></el-table-column>
				<el-table-column prop="mobile" key="mobile" label="手机号" header-align="center" align="center">
					<template slot-scope="scope">
						<span v-if="isSourceOfTax == 1">{{hideName(scope.row.mobile)}}</span>
						<span v-else>{{scope.row.mobile}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column v-if="dataForm.userType == 'gryh'" key="ishtong" label="查看合同" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button v-if="scope.row.platContractDTOs && scope.row.platContractDTOs.length == 1" type="text" size="small" style="padding:0 15px !important;"
							@click="gryhContractHandle(scope.row.platContractDTOs[0].fddPdfViewUrl)">查看
						</el-button>
						<div v-else-if="scope.row.platContractDTOs && scope.row.platContractDTOs.length > 1">
							<el-button v-if="scope.row.userType == 'gryh'" type="text" size="small" style="padding:0 15px !important;"
								@click="contractVisableAA(scope.row.platContractDTOs)">查看
							</el-button>
						</div>
					</template>
				</el-table-column> -->
				<el-table-column prop="createDate"  key="createDate" label="注册时间" header-align="center" align="center"></el-table-column>
				<el-table-column prop="sourceOrg" label="来源企业" header-align="center" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{ scope.row.sourceOrg == 'HY' ? '海茵科技' : '' }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="isEnable" key="isEnable" :label="$t('user.status')" header-align="center" align="center" v-if="isSourceOfTax != 1">
					<template slot-scope="scope">
						<div v-if="scope.row.userType == 'qyyh'">
							<div v-if="scope.row.caStatus != 9">
							<!-- <div v-if="dataForm.bodyId == '1453241566079012865'"> -->
								<span v-if="scope.row.status === 0" >停用</span>
								<span v-else>启用</span>
							</div>
							<div v-else-if="scope.row.caStatus == 9">
								<span v-if="scope.row.status === 0" >停用</span>
								<span v-else>启用</span>
							</div>
							<span v-else>— —</span>
						</div>
						<div v-else>
							<span v-if="scope.row.status === 0" >停用</span>
							<span v-else>启用</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="userStatus" key="userStatus" label="审核状态" header-align="center" align="center" v-if="isSourceOfTax != 1">
					<template slot-scope="scope">
						<span>
							<el-tag v-if="scope.row.userStatus == 0" size="small" type="danger">待提交</el-tag>
							<el-tag v-if="scope.row.userStatus == 1" size="small" type="warning">待审核</el-tag>
							<el-tag v-if="scope.row.userStatus == 2" size="small" type="success">已审核</el-tag>
						</span>
						<!-- <span v-else>
							<el-tag v-if="scope.row.caStatus == 4 || scope.row.caStatus == 7" size="small" type="danger" style="display: block;">{{handleStatusType(scope.row.caStatus)}}</el-tag>
							<el-tag v-else  type="success" size="small" style="display: block;">{{handleStatusType(scope.row.caStatus)}}</el-tag>
						</span> -->
						
					</template>
				</el-table-column>
				<el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="250">
					<template slot-scope="scope">
						<el-button v-if="scope.row.userType == 'gryh' && scope.row.status === 0 && $hasPermission('user:userList:qy')" type="text" size="small" @click="$hasPermission('user:userList:qy') && enableOrDisableHandle(scope.row.id, 1)">启用</el-button>
							<el-button v-if="scope.row.userType == 'gryh' && scope.row.status === 1 && $hasPermission('user:userList:ty')" type="text" size="small" @click="$hasPermission('user:userList:ty') && enableOrDisableHandle(scope.row.id, 0)">停用</el-button>
						<el-button v-if="$hasPermission('user:userList:update') && scope.row.userType == 'gryh'" type="text" size="small" @click="grUpdateHandle(scope.row.id)">{{ $t("update") }}</el-button>
						<el-button v-if="$hasPermission('user:userList:ckxq') && scope.row.userType == 'gryh'" type="text" size="small" @click="grchildHandle(scope.row.id, scope.row.status)">查看详情</el-button>
						<el-button v-if="isSourceOfTax == 1" type="text" size="small" @click="downFillAll(scope.row.id, scope.row.status)">下载资料</el-button>
						<span v-if="scope.row.remark == 'add_by_agent'">
							<el-button v-if="scope.row.status === 0 && scope.row.caStatus == 9 && $hasPermission('user:userList:qy')" type="text" size="small" @click="$hasPermission('user:userList:qy') && enableOrDisableHandle(scope.row.id, 1)">启用</el-button>
							<el-button v-if="scope.row.status === 1 && scope.row.caStatus == 9 && $hasPermission('user:userList:ty')" type="text" size="small" @click="$hasPermission('user:userList:ty') && enableOrDisableHandle(scope.row.id, 0)">停用</el-button>
							<el-button type="text" size="small" @click="qychildHandleAgent(scope.row)" v-if="$hasPermission('user:userList:ckxq') && scope.row.caStatus > 1 && scope.row.caStatus < 8 && scope.row.caStatus != 3">查看信息</el-button>
							<el-button type="text" size="small" @click="qychildHandleAgent(scope.row)" v-if="$hasPermission('user:userList:shqyxx') && scope.row.caStatus == 3">审核企业信息</el-button>
							<el-button type="text" size="small" @click="qychildHandleAgent(scope.row,'addContract')" v-if="$hasPermission('user:userList:shsfht') && scope.row.caStatus == 6">审核三方合同</el-button>
							<el-button type="text" size="small" @click="qychildHandleAgent(scope.row,'addContract')" v-if="$hasPermission('user:userList:ckxq') && scope.row.caStatus == 7">查看三方合同</el-button>
							<el-button type="text" size="small" @click="qychildHandleAgent(scope.row,'addContract')" v-if="$hasPermission('user:userList:ckxq') && scope.row.caStatus == 8 || scope.row.caStatus == 9">查看详情</el-button>
							<el-button type="text" size="small" @click="qychildHandleAgent(scope.row,'addContract','isEdit')" v-if="$hasPermission('user:userList:update') && scope.row.caStatus == 9">修改</el-button>
							<el-button type="text" size="small" v-if="scope.row.caStatus == 8 && $hasPermission('user:userList:kh')" @click="openHandle(scope.row)">开户</el-button>
							<el-button v-if="scope.row.caStatus == 9 && $hasPermission('user:userList:tk')" type="text" size="small" @click="openRefund(scope.row)">退款</el-button>
							<el-button v-if="scope.row.caStatus == 9 && $hasPermission('user:userList:yggl')" type="text" size="small" @click="fnOpenStaff(scope.row)">员工管理</el-button>
						</span>
						<span v-else>
							<el-button v-if="scope.row.status === 0 && $hasPermission('user:userList:qy')" type="text" size="small" @click="$hasPermission('user:userList:qy') && enableOrDisableHandle(scope.row.id, 1)">启用</el-button>
							<el-button v-if="scope.row.status === 1 && $hasPermission('user:userList:ty')" type="text" size="small" @click="$hasPermission('user:userList:ty') && enableOrDisableHandle(scope.row.id, 0)">停用</el-button>
							<el-button v-if="$hasPermission('user:userList:update') && scope.row.userType == 'qyyh'" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t("update") }}</el-button>
							<el-button v-if="scope.row.userType == 'qyyh' && $hasPermission('user:userList:ckxq')" type="text" size="small" @click="qychildHandle(scope.row.id, scope.row.status)">查看详情</el-button>
							<el-button v-if="$hasPermission('user:userList:kh') && scope.row.userType == 'qyyh'" type="text" size="small" @click="openHandle(scope.row)">开户</el-button>
							<el-button v-if="$hasPermission('user:userList:tk') && scope.row.userType == 'qyyh' && role == 'OPERATE'" type="text" size="small" @click="openRefund(scope.row)">退款</el-button>
							<el-button v-if="$hasPermission('user:userList:yggl') && scope.row.userType == 'qyyh'" type="text" size="small" @click="fnOpenStaff(scope.row)">员工管理</el-button>
						</span>
						
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
				layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle">
			</el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
			<gr-update v-if="grUpdateVisible" ref="grUpdate" @refreshDataList="getDataList"></gr-update>
			<open v-if="openVisible" ref="open" @refreshDataList="getDataList"></open>
			<el-dialog v-if="$hasPermission('sys:user:importExcel') && batchImportDia" :title="modalName" :visible.sync="batchImportDia" width="400px" :before-close="handlerCloseSubmit">
				<div class="batchImport">
					<el-upload ref="upload" action="" accept=".xls,.xlsx" :on-change="handleChange"
						:http-request="modalVal == 1 ? fileUpload : fileUpload1" :multiple="false" :file-list="batchImportList"
						:auto-upload="false">
						<el-button slot="trigger" size="small">选取文件</el-button>
						<div slot="tip" class="el-upload__tip">只能上传excel文件</div>
					</el-upload>
					<!-- <span style="color:#333;">下载模板后导入</span> -->
					<el-button @click="downloadTem()" class="exportBtn" v-if="dataForm.userType == 'gryh' && modalVal == 1"  type="text" size="small">下载模版</el-button>
					<el-button @click="bathImportUserDown()" class="exportBtn" v-if="dataForm.userType == 'gryh' && modalVal != 1" type="text" size="small">下载用户检测模板
					</el-button>
				</div>
				<div slot="footer" class="dialog-footer">
				<el-button @click="closeSubmit">取 消</el-button>
				<el-button type="primary" @click="confirmSubmit">确 定</el-button>
				</div>
			</el-dialog>

			<!-- 下载选择月份 -->
			<el-dialog title="选择月份" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
				<el-date-picker v-model="year" type="month" :picker-options="pickerOptions" value-format="yyyy-MM" placeholder="选择月"></el-date-picker>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="handleExport()">确 定</el-button>
				</span>
			</el-dialog>
		</div>
		<!-- 新增 退款 -->
		<refundAdd ref="refundAdd" v-if="refundAddVisable"></refundAdd>
		<!-- 合同弹框 -->
		<el-dialog  class="contractDia" title="查看合同" :visible.sync="contractVisable" width="30%" :before-close="contractChange">
			<div v-for="(item,index) in contractList">
				<el-button type="text" size="small" class="contractBtn" @click="gryhContractHandle(item.fddPdfViewUrl)">{{item.abbreviation}}</el-button>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
			</span>
		</el-dialog>
	</el-card>
</template>

<script>
  import mixinViewModule from "@/mixins/view-module";
  import AddOrUpdate from "./user-edit";
import ArrayUtils from "../../../utils/ArrayUtils";
  import refundAdd from "./refund-add.vue";
  import GrUpdate from "./gruser-edit";
  import Open from "./open-account";
  import { addDynamicRoute } from "@/router";
  import DataUtils from "../../../utils/DataUtils"

  import qs from "qs";
  import Cookies from "js-cookie";
  export default {
		mixins: [mixinViewModule],
		data() {
			return {
				isSourceOfTax:Cookies.get("isSourceOfTax"),
				caStatus:[
					{value:1,label:'企业信息待提交'},
					{value:2,label:'三方合同待提交'},
					{value:3,label:'企业信息审核中'},
					{value:4,label:'企业信息审核驳回'},
					{value:5,label:'企业信息审核通过'},
					{value:6,label:'三方合同审核中'},
					{value:7,label:'三方合同审核驳回'},
					{value:8,label:'三方合同审核通过'},
					{value:9,label:'已开户'}
				],
				bodyInfo:'',//税源地列表
				contractVisable:false,
				contractList:[],
				refundAddVisable: false,
				pickerOptions: {
				disabledDate(time) {
					const FullYear = time.getFullYear();
					let myDate = new Date();
					if (FullYear < 2018) {
						return true;
					} else {
						let t = myDate.getDate();
							// 如果想包含本⽉本⽉ - 8.64e7 * t 就不需要了，
							// 如果想之前的不能选择把 > 换成 <
							return time.getTime() > Date.now();
						}
					},
				},
				year: "",
				dialogVisible: false,
				modalName: "",
				modalVal: 1,
				grUpdateVisible: false,
				openVisible: false,
				mixinViewModuleOptions: {
					createdIsNeed:false,
					// pageList
					getDataListURL: "/sys/user/page",
					getDataListIsPage: true,
					deleteURL: "/sys/user",
					deleteIsBatch: true,
					exportURL: "/sys/user/export",
				},
				jiesuan: [{value: "qyyh",label: "企业用户"},{value: "gryh",label: "个人用户"}],
				role: Cookies.get("admin_role"),
				dataForm: {
					username: "",
					deptId: "",
					gender: "",
					userType: "qyyh",
					userStatus: "",
					month: "",
					caName: "",
					realName: "",
					idCard: "",
					caStatus:"",
					bodyId:''
					// bodyId:'1453241566079012865'
				},
				batchImportDia: false,
				batchImportList: [],
			};
		},
		components: {
			AddOrUpdate,
			GrUpdate,
			Open,
			refundAdd,
		},
		created(){
			// 获取税源地列表
			this.$http.get(`/sys/plat/body/page?order=&orderField=&page=1&limit=1000&sydEdit=1`).then(({ data: res }) => {
				this.bodyInfo = res.data.list;
				if(this.isSourceOfTax == 1){
					const bodyInfo = [ArrayUtils.getItemBy(res.data.list, "id", this.$store.state.user.bodyIds )]
					this.dataForm.bodyId = bodyInfo[0].id
					this.dataForm.caStatus = 9
					this.getDataList();
				}else{
					this.getDataList();
				}
			})
		},
		methods: {
			downFillAll(id,status){
				this.$alert('打包下载中,下载资料包括：营业执照+公司门头照+公司场景照片+风控表+合同', '温馨提示', {
					confirmButtonText: '确定',
					callback: action => {
						// this.$message({
						// 	type: 'info',
						// 	message: `action: ${ action }`
						// });
					window.open(`${window.SITE_CONFIG["apiURL"]}/sys/plat/info/ca/packageDownload?id=${id}`)
					}
				});
			},
			hideName: DataUtils.hideName,
			// 匹配状态
			handleStatusType(caStatus){
				return ArrayUtils.getItemBy(this.caStatus, "value", caStatus ).label
			},
			// 切换税源地
			handleChangeBodyId(e){
				console.log(e)
				this.dataForm.caStatus = ''
				this.dataForm.userStatus = ''
				this.dataForm.bodyId = e;
				this.getDataList();
			},
			// 查看合同
			contractVisableAA(row){
				this.contractVisable = true;
				this.contractList = row;
			},
			contractChange(){
				this.contractVisable = false;
			},
			// 员工管理
			fnOpenStaff(row){
				localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm));
				const routeParams = {
					routeName: `${this.$route.name}__员工管理`,
					title: `员工管理`,
					path: "user/user-listjg-staff",
					params: {
						rowObj:JSON.stringify(row)
					},
				};
				// 动态路由
				addDynamicRoute(routeParams, this.$router);
			},
			// 退款功能
			openRefund(row) {
				this.refundAddVisable = true;
				this.$nextTick(() => {
					this.$refs.refundAdd.init();
					this.$refs.refundAdd.dataForm.caId = row.id;
					this.$refs.refundAdd.dataForm.caName = row.caName;
				});
			},
			getdataTime() {
				var now = new Date();
				var year = now.getFullYear(); // 得到年份
				var month = now.getMonth(); // 得到月份
				var date = now.getDate(); // 得到日期
				month = month + 1;
				month = month.toString().padStart(2, "0");
				date = date.toString().padStart(2, "0");

				var defaultDate = `${year}-${month}`;
				return defaultDate;
			},
			// 导出电话核查表
			hanleExportPhone() {
				this.year = this.getdataTime();
				this.dialogVisible = true;
			},
			handleClose() {
				this.dialogVisible = false;
			},
			handleExport() {
				if (this.year == this.getdataTime()) {
					this.$http.get(`${window.SITE_CONFIG["apiURL"]}/sys/plat/deal/approval/exportUsersByMonth?access_token=${Cookies.get("access_token")}`).then((res) => {
						if (res.data.code == 500) {
							this.$message.error(res.data.msg);
							return;
						} else {
							window.open(`${window.SITE_CONFIG["apiURL"]}/sys/plat/deal/approval/exportUsersByMonth?access_token=${Cookies.get("access_token")}`);
						}
					});
				} else {
					this.$http.get(`${window.SITE_CONFIG["apiURL"]}/sys/plat/deal/approval/exportUsersByMonth?month=${this.year}&access_token=${Cookies.get("access_token")}`).then((res) => {
						if (res.data.code == 500) {
							this.$message.error(res.data.msg);
							return;
						} else {
							window.open(`${window.SITE_CONFIG["apiURL"]}/sys/plat/deal/approval/exportUsersByMonth?month=${this.year}&access_token=${Cookies.get("access_token")}`);
						}
					});
				}
				this.dialogVisible = false;
			},
			enableOrDisableHandle(id, isEnable) {
				console.log(isEnable)
				this.$confirm("此操作" + (isEnable == 0 ? "将禁用" : "将启用") + "此条数据, 是否继续?","提示",{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.handle(id, isEnable);
				}).catch(() => {
					this.$message({
					type: "info",
					message: "已取消操作",
					});
				});
			},
			handle(id, isEnable) {
				this.$http.get(`/sys/user/enableOrDisable?id=${id}&status=${isEnable}`).then(({ data: res }) => {
					if (res.code !== 0) {
						return this.$message.error(res.msg);
					} else {
						this.$message({
							message: this.$t("prompt.success"),
							type: "success",
							duration: 500,
							onClose: () => {
								this.query();
							},
						});
					}
				})
				.catch(() => { });
			},
			grUpdateHandle(id) {
				this.grUpdateVisible = true;
				this.$nextTick(() => {
					this.$refs.grUpdate.init();
					this.$refs.grUpdate.dataForm.id = id;
				});
			},
			grchildHandle(id, status) {
				localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm));
				// 路由参数
				const routeParams = {
					routeName: `${this.$route.name}__个人查看详情`,
					title: `个人查看详情`,
					path: "user/edit-gryh-user",
					params: {
						id: id,
						status: status,
					},
				};
				// 动态路由
				addDynamicRoute(routeParams, this.$router);
			},
			qychildHandle(id, status) {
				localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm));
				// 路由参数
				const routeParams = {
					routeName: `${this.$route.name}__企业查看详情`,
					title: `企业查看详情`,
					path: "user/edit-qyyh-user-old",
					params: {
						id: id,
						status: status,
					},
				};
				// 动态路由
				addDynamicRoute(routeParams, this.$router);
			},
			qychildHandleAgent(row,addContract,isEdit) {
				localStorage.setItem(this.$route.name, JSON.stringify(this.dataForm));
				// 路由参数
				const routeParams = {
					routeName: `${this.$route.name}__查看详情`,
					title: `查看详情`,
					path: "user/edit-qyyh-user",
					params: {
						id: row.id,
						userStatus: row.userStatus,
						addContract:addContract ? true : false,
						isEdit:isEdit ? true : false
					},
				};
				// 动态路由
				addDynamicRoute(routeParams, this.$router);
			},
			// 企业用户下载导出
			qychildHandleDown(id, status) {
				var params = qs.stringify({
					access_token: Cookies.get("access_token"),
					bodyId: id.toString(","),
				});
				this.$http.get(`${window.SITE_CONFIG["apiURL"]}/sys/plat/platticketrecord/exportProviderList?${params}`).then(({ data: res }) => {
					if (res.data && res.data.length <= 0) {
						this.$message.error("当前文档为空！");
					} else {
						window.open(`${window.SITE_CONFIG["apiURL"]}/sys/plat/platticketrecord/exportProviderList?${params}`);
					}
				});
			},
			getvalue(e) {
				this.dataForm.userType = e;
				this.dataForm.deptId = "";
				this.dataForm.gender = "";
				this.dataForm.userStatus = "";
				this.dataForm.month = "";
				this.dataForm.username = "";
				this.dataForm.caName = "";
				this.dataForm.realName = "";
				if(e == 'gryh'){
					this.dataForm.idCard = "";
				}
				this.dataForm.bodyId = "";
				this.getDataList();
			},
			bathImportUser(name, modalVal) {
				this.modalName = name;
				this.modalVal = modalVal;
				this.batchImportDia = true;
			},
			bathImportUserDown() {
				window.open("https://pg-crm-upload-uat-01.oss-cn-beijing.aliyuncs.com/lhyg1/20220402/6103bfe1df4b4dd79a85dd4964bfaeb0.xlsx");
			},

			closeSubmit() {
				this.batchImportList = [];
				this.batchImportDia = false;
			},
			handlerCloseSubmit(done) {
				this.closeSubmit();
				done();
			},
			// 个人用户查看合同
			gryhContractHandle(url) {
				window.open(url);
			},
			confirmSubmit() {
				this.$refs.upload.submit();
			},
			handleChange(file, fileList) {
				console.log(file, fileList);
				this.batchImportList = [file];
			},
			fileUpload(file) {
				let form = new FormData();
				form.append("file", file.file);
				this.$http.post("/sys/user/importExcel", form).then(({ data: res }) => {
					if (res.code !== 0) {
						this.$message.error(res.msg);
						return;
					}
					this.$message.success("导入成功");
					this.closeSubmit();
					this.getDataList();
				}).catch((err) => { });
			},
			fileUpload1(file) {
				let form = new FormData();
				form.append("file", file.file);
				this.$http.post("/sys/user/importCheckUsers", form, { responseType: "blob" }).then(({ data: res }) => {
					// if (res.code !== 0) {
					// 	this.$message.error(res.msg);
					// 	return ;
					// }
					let str = file.file.name;
					this.exportExcel(res, str.substring(0, str.indexOf(".")));
					this.$message.success("导入成功");
					this.closeSubmit();
					this.getDataList();
				})
				.catch((err) => { });
			},
			exportExcel(data, name) {
				let blob = new Blob([data], { type: "application/vnd.ms-excel" }); // 设置文件类型excel
				let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
				// 创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
				let a = document.createElement("a");
				a.href = url;
				a.download = name + ".xlsx";
				a.click();
				// 释放这个临时的对象url
				window.URL.revokeObjectURL(url);
			},
			downloadTem() {
				window.open("https://pg-crm-upload-uat-01.oss-cn-beijing.aliyuncs.com/lhyg1/20220402/2fd052c510554176b2658d1bfa49deae.xlsx");
			},
		},
	};
</script>
<style lang="scss" scoped>
  .batchImport {

    /deep/ .el-list-enter-active,
    /deep/ .el-list-leave-active {
      transition: none;
    }

    /deep/ .el-list-enter,
    /deep/ .el-list-leave-active {
      opacity: 0;
    }

    /deep/ .el-upload-list {
      height: 40px;
    }
  }
  .contractBtn{
    padding:10px 50px;
    background:#F3F5FA;
    font-size:12px;
    color:#3A7DD1;
    border: 1px solid #3A7DD1;
    margin-bottom:9px;
  }

.mod-sys__user {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
  
  .el-table {
    flex: 1;
    margin-top: 20px;
    overflow: auto;
  }
  
  .el-pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }
}
</style>